import Vue from 'vue'
import Antd from 'ant-design-vue'
import '@/static/css/lyq-theme.less'
Vue.use(Antd)
